import {
  DeviceRegistryCommandFunctionType,
  DeviceRegistryCommandKey
} from '@tryiris-ai/common.protojs/api/v1/device_settings';
import { focus } from './focus.js';
import type { Stop } from './types.js';

/**
 * Stop focus.
 *
 * @param deviceId - The ID of the device whose focus is to be stopped.
 * @returns A promise that resolves when the command has been processed.
 */
export const stop: Stop = async (deviceId) =>
  focus(deviceId, [
    DeviceRegistryCommandKey.FOCUS_ABSOLUTE,
    DeviceRegistryCommandFunctionType.STOP
  ]);
